import React from 'react';
import type { FloatingReaction } from '../types/meeting.types.ts';

interface FloatingReactionsProps {
  reactions: FloatingReaction[];
}

const FloatingReactions: React.FC<FloatingReactionsProps> = ({ reactions }) => {
  if (reactions.length === 0) return null;

  return (
    <div className="pointer-events-none fixed inset-0 z-[35] overflow-hidden">
      {reactions.map((reaction) => (
        <span
          key={reaction.id}
          className="absolute bottom-28 text-4xl animate-float-reaction select-none"
          style={{ left: `${reaction.leftPercent}%` }}
        >
          {reaction.emoji}
        </span>
      ))}
    </div>
  );
};

export default FloatingReactions;
